import { api } from '@/lib/api/client';
import type { AuthTokens, Locale, User } from '@/lib/api/types';

export const authApi = {
  login(body: { email: string; password: string; totp_code?: string }): Promise<AuthTokens> {
    return api.post<AuthTokens>('/admin/auth/login', body);
  },
  forgot(email: string): Promise<{ status: string }> {
    return api.post('/admin/auth/forgot', { email });
  },
  reset(token: string, password: string): Promise<{ status: string }> {
    return api.post('/admin/auth/reset', { token, password });
  },
  // Self-service (spec §15.1a)
  updateMe(body: { name?: string; locale?: Locale }): Promise<User> {
    return api.patch<User>('/admin/me', body);
  },
  changePassword(body: { current_password: string; new_password: string }): Promise<null> {
    return api.post('/admin/me/password', body);
  },
  /**
   * Starts enrolment. With 2FA already on this is a rotation to a new phone and
   * `currentCode` (from the authenticator in use now) is required (D-209).
   */
  mfaEnroll(currentCode?: string): Promise<{ secret: string; otpauth_url: string }> {
    return api.post('/admin/me/mfa/enroll', currentCode ? { code: currentCode } : undefined);
  },
  /**
   * Confirms the new authenticator. be-svet ends every other session of the
   * account and answers with a fresh full session (and refresh cookie), which
   * the caller must adopt — the one it was using is gone.
   */
  mfaVerify(code: string): Promise<AuthTokens> {
    return api.post<AuthTokens>('/admin/me/mfa/verify', { code });
  },
};
